import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/Admin.vue"),
    redirect: "/LectureList",
    children: [
      {
        path: "/AddLecture",
        name: "AddLecture",
        component: () => import("../components/lecture/AddLecture.vue"),
        meta: { title: "新增讲座" },
      },
      {
        path: "/LectureList",
        name: "LectureList",
        component: () => import("../components/lecture/LectureList.vue"),
        meta: { title: "讲座列表" },
      },
      {
        path: "/HistoryList",
        name: "HistoryList",
        component: () => import("../components/lecture/HistoryList.vue"),
        meta: { title: "历史讲座" },
      },
      {
        path: "/CommentList",
        name: "CommentList",
        component: () => import("../components/lecture/CommentList.vue"),
        meta: { title: "评论管理" },
      },
      {
        path: "/Category",
        name: "Category",
        component: () => import("../components/category/CategoryList.vue"),
        meta: { title: "分类" },
      },
      {
        path: "/Points",
        name: "Points",
        component: () => import("../components/points/SendPoints.vue"),
        meta: { title: "积分" },
      },
      {
        path: "/AddLecture/:id",
        name: "EditLecture",
        component: () => import("../components/lecture/AddLecture.vue"),
        meta: { title: "编辑讲座" },
        props: true,
      },
      {
        path: "/ApprovalList",
        name: "ApprovalList",
        component: () => import("../components/lecture/ApprovalList.vue"),
        meta: { title: "讲座审核" },
      },
      {
        path: "/UploadApproval",
        name: "UploadApproval",
        component: () => import("../components/user/UploadApproval.vue"),
        meta: { title: "上传权限审核" },
      },
      {
        path: "/UserList",
        name: "UserList",
        component: () => import("../components/user/UserList.vue"),
        meta: { title: "用户管理" },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = window.sessionStorage.getItem("token");
  if (to.path === "/login") {
    if (token) return next("/admin");
    return next();
  }
  if (!token) return next("/login");
  next();
});

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} - 讲座管理` : "讲座管理";
});

export default router;
